import { useBreakpointValue } from "@gluestack-ui/themed";
import { MenuActionItemProps } from "@repo/core/components/layout/MenuActionsList/components/MenuActionItem/types";
import { InstallmentSimulateOperationTypeEnum } from "@repo/core/enums/installments";
import { useNavigation } from "@repo/core/hooks/useNavigation";
import { ROUTES } from "@repo/core/routes";

export const SimulateOptionsController = () => {
  const { back, push } = useNavigation();
  const isMobile = useBreakpointValue({ base: true, md: false });
  const menuActionItems: MenuActionItemProps[] = [
    {
      title: "Parcelamento de Compra",
      onPress: () =>
        push(ROUTES.simulateInstallmentsValue, {
          operationType: InstallmentSimulateOperationTypeEnum.PURCHASE
        })
    },
    {
      title: "Parcelamento de Saque",
      onPress: () =>
        push(ROUTES.simulateInstallmentsValue, {
          operationType: InstallmentSimulateOperationTypeEnum.WITHDRAW
        })
    }
  ];
  return { back, isMobile, menuActionItems };
};
